import { makeAutoObservable } from "mobx";
import { PermissionsUserInfo } from "../../../api/typings/Permissions";
import { User } from "../../../api/typings/Users";
import { AuthService } from "../../services/users/AuthService";
import { uiStore } from "../UiStore/UiStore";
import { clearTokens } from "../../../helpers/cookies";

export interface LoginOptions {
  username: string;
  password: string;
  rememberMe: boolean;
}

class AuthStore {
  authenticatedUser: Record<string, User> = {};

  permissions: PermissionsUserInfo = {};

  isLogged: boolean = false;

  authService: AuthService;

  constructor() {
    this.authService = new AuthService(this);
    makeAutoObservable(
      this,
      {},
      {
        deep: true,
      }
    );
  }

  me = async () => {
    try {
      uiStore.startPending();
      await this.authService.me();
    } catch (e) {
      uiStore.notify({
        message: "Произошла ошибка! Попробуйте перезагрузить страницу.",
        options: { variant: "error" },
      });
    } finally {
      uiStore.stopPending();
    }
  };

  login = async (data: LoginOptions) => {
    try {
      uiStore.startPending();
      await this.authService.login(data);
    } catch (e) {
      uiStore.notify({
        message: "Произошла ошибка! Проверьте правильность введенных данных.",
        options: { variant: "error" },
      });
    } finally {
      uiStore.stopPending();
    }
  };

  logout = () => {
    clearTokens();
    this.isLogged = false;
    // todo logout
  };

  refreshToken = async (token: string) => {
    try {
      uiStore.startPending();
      await this.authService.token(token);
    } catch (e) {
      this.isLogged = false;
      // Ui error
    } finally {
      uiStore.stopPending();
    }
  };

  setPermissions = (permissions: PermissionsUserInfo) => {
    this.permissions = { ...permissions };
  };

  get authenticatedUserId() {
    return Object.keys(this.authenticatedUser)[0];
  }
}

export const authStore = new AuthStore();
